import { Box } from '@mantine/core';

import type { IconPropsType } from './types';

export const CancelFillIcon = ({ size = 24, sx, ...props }: IconPropsType) => (
  <Box
    component="svg"
    sx={sx}
    width={size}
    height={size}
    viewBox="0 0 24 25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 12.5C20 8.08172 16.4182 4.5 12 4.5C7.58172 4.5 4 8.08172 4 12.5C4 16.9182 7.58172 20.5 12 20.5C16.4182 20.5 20 16.9182 20 12.5Z"
      fill="#E63535"
    />
    <path
      d="M13.6465 10.1465C13.8417 9.95123 14.1582 9.95124 14.3535 10.1465C14.5488 10.3417 14.5488 10.6582 14.3535 10.8535L12.707 12.5L14.3535 14.1465L14.417 14.2246C14.5453 14.4186 14.5243 14.6826 14.3535 14.8535C14.1827 15.0243 13.9187 15.0459 13.7246 14.918L13.6465 14.8535L12 13.207L10.3535 14.8535C10.1582 15.0486 9.84168 15.0487 9.64648 14.8535C9.45151 14.6583 9.4515 14.3417 9.64648 14.1465L11.293 12.5L9.64648 10.8535L9.58203 10.7754C9.45387 10.5813 9.47562 10.3173 9.64648 10.1465C9.81735 9.97564 10.0813 9.95387 10.2754 10.082L10.3535 10.1465L12 11.793L13.6465 10.1465Z"
      fill="white"
    />
  </Box>
);
